import type { FC } from 'react';
import React from 'react';
import { Box, Pill, useDirection } from '@edreamsodigeo/prisma-design-system';

const Tooltip: FC = ({ children }) => {
  const isRightToLeft = useDirection();

  return (
    <Box
      display="inline-block"
      position="relative"
      zIndex={1000}
      data-chromatic="ignore"
      dir="auto"
    >
      <Pill
        type="deals"
        sx={{
          fontSize: '12px',
          paddingY: 'tiny',
          paddingX: '5px',
          lineHeight: '18px',
          zIndex: 1000,
          bottom: '100%',
          left: '50%',
          transform: `translate(${isRightToLeft ? '' : '-'}40%, -26px)`,
          cursor: 'pointer',
        }}
      >
        {children}
        <Box
          sx={{
            transform: 'translateX(-50%)',
          }}
          width="0px"
          height="0px"
          position="absolute"
          borderStyle="solid"
          bottom="-4px"
          left="50%"
          borderWidth="4px 4px 0 4px"
          borderColor="#f06019 transparent transparent transparent"
        />
      </Pill>
    </Box>
  );
};

export default Tooltip;
